const STORAGE_KEY = 'offline_requests_queue';

const OfflineStorage = {
    getQueue: () => {
        try {
            const queue = localStorage.getItem(STORAGE_KEY);
            return queue ? JSON.parse(queue) : [];
        } catch (e) {
            console.error('Error reading offline queue:', e);
            return [];
        }
    },

    addToQueue: (requestConfig) => {
        try {
            const queue = OfflineStorage.getQueue();
            // Only save necessary data to replay the request
            const serializedRequest = {
                id: Date.now() + Math.random().toString(36).substr(2, 9),
                url: requestConfig.url,
                method: requestConfig.method,
                data: requestConfig.data, // Data payload
                params: requestConfig.params, // Query params
                timestamp: Date.now(),
                headers: requestConfig.headers ? { ...requestConfig.headers } : {} // Headers if needed (careful with auth)
            };

            // Remove headers that shouldn't be persisted or are dynamic (like Auth which is re-attached)
            // Usually we want to re-attach fresh Auth token when retrying, so we might not save it here.
            if (serializedRequest.headers && serializedRequest.headers.Authorization) {
                delete serializedRequest.headers.Authorization;
            }

            queue.push(serializedRequest);
            localStorage.setItem(STORAGE_KEY, JSON.stringify(queue));
            return serializedRequest.id;
        } catch (e) {
            console.error('Error saving to offline queue:', e);
            return null;
        }
    },

    removeFromQueue: (id) => {
        try {
            const queue = OfflineStorage.getQueue();
            const newQueue = queue.filter(req => req.id !== id);
            localStorage.setItem(STORAGE_KEY, JSON.stringify(newQueue));
        } catch (e) {
            console.error('Error removing from offline queue:', e);
        }
    },

    clearQueue: () => {
        localStorage.removeItem(STORAGE_KEY);
    }
};

export default OfflineStorage;
